import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
  Divider,
  useMediaQuery,
  Tooltip,
  Link,
  IconButton,
} from "@mui/material";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from "@mui/material";

import Alert from "@mui/material/Alert";
import Header from "../../common/Header";
import Button from "../../common/Button";
import Card from "../../common/Card";
import {
  OrderInfo,
  getOrderItemsByOrderId,
  TissueTrackingDetail,
  useOrderSlice,
  OrderItemDTO,
  fetchOrderDocumentById,
  orderItemInvoice,
  fetchOrderDocumentsByIds,
  getOrderTrackingLogs,
  previewPackagePDF,
  previewSalesPDF,
  previewPrescriptionPDF,
  previewCMSPDF,
  previewProofOfDelivery,
  previewEvaltionForm,
  updateOrder,
  OrderFulfillmentInfo,
} from "../../../redux/slice/order/OrderSlice";
import { useForm } from "react-hook-form";
import {
  ArrowBack,
  AssignmentOutlined,
  Cancel,
  CommentOutlined,
  ContentCopy,
  Create,
  NoteAddOutlined,
  PictureAsPdfOutlined,
  Star,
  WallpaperOutlined,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import CustomCheckbox from "../../common/CustomCheckBox";
import { tokens } from "../../../theme";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import dayjs from "dayjs";
import CustomIconButton from "../../common/CustomIconButton";
import CustomAlert from "../../common/CustomAlert";
import CustomSingleAlert from "../../common/CustomSingleAlert";
import {
  setSingleAlertObj,
  SingleAlertInfo,
  useCommonReducer,
} from "../../../redux/slice/commonSlice";
import PDFViewer from "../../common/pdf/PDFViewer";
import CustomTextField from "../../common/CustomTextField";
import CustomDatePicker from "../../common/CustomDatePicker";
import CustomItemList from "../../common/CustomItemList";
import CustomCommentPreview from "../../common/CustomCommentPreview";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { selectIsTokenAvailable, selectIsValueFoundInToken, useAuthSlice } from "../../../redux/slice/authSlice";
import {
  CAN_ACCESS_APPLICATION,
  PRODUCT_CATEGORY,
  ORDER_ACTIONS,
  ORDER_AVAILABILITY,
  ORDER_DETAILS_BUTTONS,
  ORDER_STATUS,
  PRODUCT_STATUS,
  USER_ROLE_ENTITY_NAMES,
  USER_ROLES,
} from "../../../constants/applicationConstants";
import { Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomCommentPopup from "../../common/CustomCommentPopup";
import {
  formatShippingTrackingDateTime,
  formatShippingTrackingExpectedDateTime,
  hideElement,
  priceFormatter,
} from "../../../utils/Utility";
import { getPatient } from "../../../redux/slice/patient/patientSlice";
import { useNavigation } from "../../../hooks/useNavigation";
import ShipmentInfoPopup from "./ShipmentInfoPopup";
import SigantureSubmitPopup from "./SignatureSubmitPopup";
import { saveProviderSignAgainstOrder } from "../../../redux/slice/providerNotifications/ProviderNotificationSlice";
import { SUCCESS_CODE } from "../../../service/ServiceConstants";
import { getSalesDetailsByOrderId, resetSaleDetailsStatus, SalesDetailsDTO, useSaleDetailsSlice } from "../../../redux/slice/saleDetails/SaleDetailsSlice";
import ExcelDetailsPopup from "./ExcelDetailsPopup";
import React from "react";

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "right" | "center" | "left";
  format?: (value: number) => string;
}

interface Row {
  select: any;
  orderedGrafts: string;
  serialNumber: string;
  id: number;
  tissueTrackingId: number;
  productReturnId: number;
  orderStatus: string;
  comment: string;
  tissueTrackingDocumentId: number;
  tissueTrackingInfo: {
    barcodes: number[];
    imagesOfWounds: number[];
    medicalNotes: number[];
  };
  returnDocumentId: number;
  invoice: orderItemInvoice;
  invoiceId: number;
  uploadedProductPackageIds: number[];
  appRetDate: string | JSX.Element;
  invoiceDate: string | JSX.Element;
}

const MigrateDetails = () => {
  const { control, setValue, getValues } = useForm<TissueTrackingDetail>({
    defaultValues: {
      patient: "",
      product: "",
      order: "",
      po: "",
      dateOfService: "",
      shippingCarrier: "",
      trackingNumber: "",
      orderStatus: "",
      providerName: "",
      practiceName: "",
    },
  });

  const { navigate } = useNavigation();
  const location = useLocation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useAppDispatch();
  const [order, setOrder] = useState<OrderInfo>();
  const { orderItemsListInfo, orderDocumentInfo, orderTrackingLogs } =
    useOrderSlice();
  const { SalesDetailsInfo } = useSaleDetailsSlice();
  const [showCommentPopup, setShowCommentPopup] = useState(false);
  const [commentData, setCommentData] = useState<{
    title: string;
    body: string;
  }>({
    title: "",
    body: "",
  });

  const [showCommentAlert, setShowCommentAlert] = useState(false);
  const [comment, setComment] = useState("");
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
  const [showPDF, setShowPDF] = useState<{
    isShow: boolean;
    productName: string;
    fileName: string;
  }>({ isShow: false, productName: "", fileName: "" });
  const [serialNumbers, setSerialNumbers] = useState<{ [key: number]: string }>(
    {}
  );
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mfrPatientId, setMfrPatientId] = useState<string>("");

  const [shipmentInfoOpen, setShipmentInfoOpen] = useState(false);
  const [showExcelPopup, setShowExcelPopup] = useState(false);

  const parsedTrackingInfo = orderTrackingLogs?.detailedTrackingInfo
    ? JSON.parse(orderTrackingLogs.detailedTrackingInfo)
    : null;

  const trackingData = parsedTrackingInfo?.track_info;

  const scanEvents = trackingData?.tracking?.providers[0]?.events || [];
  const dateAndTimes = trackingData?.milestone || [];
  const shippingDateRaw = dateAndTimes.find(
    (d: any) => d.key_stage === "InfoReceived"
  )?.time_iso;
  const departureTimeRaw = dateAndTimes.find(
    (d: any) => d.key_stage === "PickedUp"
  )?.time_iso;
  const timeMetrics = trackingData?.time_metrics;
  const shippingDate = formatShippingTrackingDateTime(shippingDateRaw);
  const departureTime = formatShippingTrackingDateTime(departureTimeRaw);
  const expectedArrivalFrom = formatShippingTrackingDateTime(
    timeMetrics?.estimated_delivery_date?.from
  );
  const expectedArrivalTo = formatShippingTrackingDateTime(
    timeMetrics?.estimated_delivery_date?.to
  );
  const deliveryEvent = scanEvents.find(
    (event: any) => event.stage === "Delivered"
  );
  const actualDeliveryTime = formatShippingTrackingDateTime(
    deliveryEvent?.time_iso
  );
  const canAccessSalesInvoice = useSelector((state: RootState) =>
    selectIsValueFoundInToken(
      "canAccessOrderDetailsActionButton",
      ORDER_DETAILS_BUTTONS.SALES_INVOICE
    )(state)
  );

  const canAccessApplication = useSelector((state: RootState) =>
    selectIsValueFoundInToken(
      "canAccessApplication",
      CAN_ACCESS_APPLICATION.INVOICE_MANAGEMENT
    )(state)
  );

  const canViewCOGSPrice = useSelector((state: RootState) =>
    selectIsValueFoundInToken(
      "canViewCOGSPrice",
      CAN_ACCESS_APPLICATION.ORDER_MANAGEMENT
    )(state)
  );
  //CS-1302 - Start
  const canSignOrder = useSelector((state: RootState) =>
    selectIsValueFoundInToken(
      "canAccessOrderActions",
      ORDER_ACTIONS.SIGNORDER
    )(state)
  );
  const [showSignatureSubmitPopup, setShowSignatureSubmitPopup] =
    useState<boolean>(false);
  //CS-1302 - End
  const isNotPlacedOrCanceled = !(
    order?.orderStatus === PRODUCT_STATUS.PLACED ||
    order?.orderStatus === PRODUCT_STATUS.CANCELED
  );
  const isProcessing = order?.orderStatus === PRODUCT_STATUS.PROCESSING;
  const isShipped = order?.orderStatus === PRODUCT_STATUS.SHIPPED;
  const isDelivered = order?.orderStatus === PRODUCT_STATUS.DELIVERED;

  const [isEditing, setIsEditing] = useState(false);
  const [poNumberValue, setPoNumberValue] = useState<string>(
    order?.poNumber || getValues("po") || ""
  );
  const [documentsMenuAnchor, setDocumentsMenuAnchor] =
    useState<null | HTMLElement>(null);
  const { userInfo } = useAuthSlice();
  const canViewExcelData = useSelector((state: RootState) => selectIsTokenAvailable("canViewExcelData")(state));

  // Mounting
  useEffect(() => {
    const orderDetails: OrderInfo = location?.state?.orderDetails;
    setOrder(orderDetails);
    if (orderDetails) {
      setInitialValues(orderDetails);
      dispatch(getOrderItemsByOrderId(orderDetails.orderId));
      dispatch(getSalesDetailsByOrderId(orderDetails.orderId));
      dispatch(
        getOrderTrackingLogs({
          orderId: orderDetails.orderId,
          trackingNumber: orderDetails.trackingNumber,
        })
      );
    }
    const fetchPatientDetails = async () => {
      try {
        const response = await dispatch(
          getPatient({ patientId: orderDetails.patientId.toString() })
        ).unwrap();
        const updateOrderInfo = response.data.patientInfo?.find(
          (info: { infoType: string }) =>
            info.infoType === "MANUFACTURER_PATIENT_IDS"
        );

        if (updateOrderInfo && updateOrderInfo.patientinfoData) {
          const manufacturerId = orderDetails.manufacturerId;

          const manufacturerEntries = Object.values(
            updateOrderInfo.patientinfoData
          ) as {
            manufacturerId: number;
            manufacturerPatientId: string;
          }[];

          const manufacturerEntry = manufacturerEntries.find(
            (entry) => entry.manufacturerId === manufacturerId
          );

          if (manufacturerEntry) {
            orderDetails.manufacturerPatientId =
              manufacturerEntry.manufacturerPatientId;
            setMfrPatientId(manufacturerEntry.manufacturerPatientId);
          }
        }
      } catch (error) {
        console.error("Error fetching patient details:", error);
      }
    };

    fetchPatientDetails();
  }, [location?.state?.orderDetails, dispatch]);

  //Unmount
  useEffect(() => () => {
    dispatch(resetSaleDetailsStatus())
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: { key: string }) => {
      if (event.key === "Escape") {
        setShowCommentAlert(false);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const setInitialValues = (orderDetails: OrderInfo) => {
    setValue("order", orderDetails.orderNumber);
    if (orderDetails.patientId) {
      setValue("patient", orderDetails.patientName);
    }
    setValue("product", orderDetails.productName);
    setValue("po", orderDetails.poNumber);
    setValue(
      "dateOfService",
      dayjs(orderDetails.dateOfService).format("MM/DD/YYYY")
    );
    setValue("shippingCarrier", orderDetails.shippingCarrier);
    setValue("trackingNumber", orderDetails.trackingNumber);
    setValue("orderStatus", orderDetails.orderStatus);
    setValue(
      "providerName",
      orderDetails.providerName || orderDetails?.orderInfo?.provider
    );
    setValue("practiceName", orderDetails.practiceName);
  };

  const getComment = (item: OrderItemDTO) => {
    if (item.tissueTrackingInfo && item.tissueTrackingInfo.comment) {
      return item.tissueTrackingInfo.comment;
    } else if (item?.returnTrackingInfo?.additionalContext) {
      return item.returnTrackingInfo.additionalContext;
    }
    return "";
  };

  const handlePreviewAction = async (row: Row) => {
    let documentId = row.tissueTrackingDocumentId
      ? row.tissueTrackingDocumentId
      : row.returnDocumentId;
    const actionResult = await dispatch(fetchOrderDocumentById(documentId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName:
          order?.productName +
          (orderItemStatus(row) === `Returned (#${row.productReturnId})`
            ? ` - RETURN`
            : ` - TISSUE TRACKING`),
        fileName:
          orderItemStatus(row) === `Returned (#${row.productReturnId})`
            ? `RETURN_${order?.orderNumber}`
            : `TISSUE_TRACKING_${order?.orderNumber}`,
      });
    }

    handleMenuClose(row.id.toString());
  };

  const handleImageViewAction = async (row: Row) => {
    let documentIds =
      row.tissueTrackingInfo?.imagesOfWounds?.length > 0
        ? row.tissueTrackingInfo.imagesOfWounds
        : row.uploadedProductPackageIds?.length > 0
        ? row.uploadedProductPackageIds
        : [];
    const actionResult = await dispatch(fetchOrderDocumentsByIds(documentIds));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName:
          row.uploadedProductPackageIds?.length > 0
            ? order?.productName + " - PRODUCT PACKAGING IMAGES"
            : order?.productName +
              (orderItemStatus(row) === `Returned (#${row.productReturnId})`
                ? ` - RETURN`
                : ` - TISSUE TRACKING`),
        fileName:
          row.uploadedProductPackageIds?.length > 0
            ? `PRODUCT_PACKAGING_IMAGES_${order?.orderNumber}`
            : orderItemStatus(row) === `Returned (#${row.productReturnId})`
            ? `RETURN_${order?.orderNumber}`
            : `TISSUE_TRACKING_${order?.orderNumber}`,
      });
    }
    handleMenuClose(row.id.toString());
  };

  const handleViewMedicalNotesAction = async (row: Row) => {
    let documentIds = row.tissueTrackingInfo?.medicalNotes ?? [];
    const actionResult = await dispatch(fetchOrderDocumentsByIds(documentIds));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: order?.productName + " - TISSUE TRACKING",
        fileName: `TISSUE_TRACKING_MEDICAL_NOTES_${order?.orderNumber}`,
      });
    }
    handleMenuClose(row.id.toString());
  };

  const handleSerialNumberChange = (orderItemId: number, value: string) => {
    setSerialNumbers((prev) => ({ ...prev, [orderItemId]: value }));
  };

  const dates = (row: OrderItemDTO) => {
    if (row.tissueTrackingId && row.appliedDate) {
      return dayjs(row.appliedDate).format("MM/DD/YYYY");
    } else if (row.productReturnId && row.returnedDate) {
      return dayjs(row.returnedDate).format("MM/DD/YYYY");
    } else {
      return "-";
    }
  };

  // Get the first element from the list
  const firstSalesDetail = useMemo(() => {
    return SalesDetailsInfo && SalesDetailsInfo.length > 0 ? SalesDetailsInfo[0] : null;
  }, [SalesDetailsInfo]);

  const orderItemRow: Row[] = useMemo(() => {
    let orderItems: Row[] = [];
    if (orderItemsListInfo) {
      orderItems = orderItemsListInfo
        .map((item: OrderItemDTO) => {
          return {
            select: <CustomCheckbox control={control} name="select" />,
            orderedGrafts: item.size,
            serialNumber: item.serialNumber,
            id: item.orderItemId,
            tissueTrackingId: item.tissueTrackingId,
            productReturnId: item.productReturnId,
            orderStatus: location?.state?.orderDetails?.orderStatus,
            comment: getComment(item),
            tissueTrackingDocumentId: item.tissueTrackingDocumentId,
            tissueTrackingInfo: {
              barcodes: item.tissueTrackingInfo?.barcodes || [],
              imagesOfWounds: item.tissueTrackingInfo?.imagesOfWounds || [],
              medicalNotes: item.tissueTrackingInfo?.medicalNotes || [],
            },
            returnDocumentId: item.returnDocumentId,
            invoice: item.invoice,
            invoiceId: item.invoiceId,
            uploadedProductPackageIds:
              item.returnTrackingInfo?.productBoxPictures || [],
            appRetDate: dates(item) || "N/A",
            invoiceDate: item.invoicedDate
              ? dayjs(item.invoicedDate).format("MM/DD/YYYY")
              : "-",
            units: item.units,
            extendedPrice: item.extendedPrice,
            invoiceNumber: item.mfgInvoiceNumber,
            quantity: item.quantity,
            hasSKUPrice: item.hasSKUPrice,
            productItemDescription: item.productItemDescription,
          };
        })
        .sort((a, b) => a.units - b.units);
    }
    return orderItems;
  }, [orderItemsListInfo, control, location?.state?.orderDetails?.orderStatus]);

  // Extract serial numbers and sizes from SalesDetailsInfo using useMemo
  // const allSerialNumbers = useMemo(() => {
  //   return SalesDetailsInfo ? [SalesDetailsInfo.serialNumber].filter(Boolean) : [];
  // }, [SalesDetailsInfo]);

  const allSerialNumbers = useMemo(() => {
    if (!firstSalesDetail?.serialNumber) return [];
    
    return firstSalesDetail.serialNumber
        .split(/\s+/) // Split by one or more whitespace characters
        .filter(Boolean); // Remove any empty strings
}, [firstSalesDetail]);

  // const allSizes = useMemo(() => {
  //   return SalesDetailsInfo?.prodSize
  //     ? SalesDetailsInfo.prodSize.split(',').map(size => size.trim()).filter(Boolean)
  //     : [];
  // }, [SalesDetailsInfo]);

  const allSizes = useMemo(() => {
    return firstSalesDetail?.prodSize
      ? firstSalesDetail.prodSize.split(/\s+/).map(size => size.trim()).filter(Boolean)
      : [];
}, [firstSalesDetail]);

  const orderItemStatus = useCallback((row: Row) => {
    if (row?.tissueTrackingId) {
      return `Applied (#${row.tissueTrackingId})`;
    } else if (row?.productReturnId) {
      return `Returned (#${row.productReturnId})`;
    } else if (row?.invoiceId) {
      return "Available";
    }
    return "Pending";
  }, []);

  const detailsColumns = [
    { id: "orderedGrafts", label: "Ordered Size" },
    { id: "serialNumber", label: "Serial Number" },
    { id: "status", label: "Status" },
    { id: "appRetDate", label: "App/Ret Date" },
    { id: "invoiceDate", label: "Invoice" },
    { id: "action", label: "Action" },
  ];

  const [menuAnchor, setMenuAnchor] = useState<{
    [key: string]: null | HTMLElement;
  }>({});

  const handleMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    rowId: string
  ) => {
    setMenuAnchor((prev) => ({ ...prev, [rowId]: event.currentTarget }));
  };

  const handleMenuClose = (rowId: string) => {
    setMenuAnchor((prev) => ({ ...prev, [rowId]: null }));
  };

  const showCustomCommentPopup = (row: any) => {
    const title = `Comment ${
      row.tissueTrackingId ? "Record product usage" : "Return product"
    }`;
    const body = row.comment || "";
    setCommentData({ title, body });
    setShowCommentPopup(true);
    handleMenuClose(row.id.toString());
  };
  const showCustomCommentPopupFromOrderForm = (row: any) => {
    const title = "Additional Notes / Comments";
    const body = row.additionalNotes;
    setCommentData({ title, body });
    setShowCommentPopup(true);
  };

  const hideCustomCommentPopup = () => {
    setShowCommentPopup(false);
  };

  // CS-991 Move PDF from action to Details Pages
  const renderPDFButton = () => (
    <Button
      color="success"
      onClick={() => order && handlePDFPreviewAction(order)}
      sx={{ whiteSpace: "nowrap" }}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      PDF
    </Button>
  );

  const renderPackingListButton = () => (
    <Button
      color="warning"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handlePackagePreview(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      Packing List
    </Button>
  );

  const renderSalesInvoiceButton = () => (
    <Button
      color="info"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handleSalesInvoicePreviw(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      Sales Invoice
    </Button>
  );

  const renderPrescriptionButton = () => (
    <Button
      color="success"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handlePrescriptionPrview(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      Prescription
    </Button>
  );

  const renderCMS1500FormButton = () => (
    <Button
      color="warning"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handleCMSPrview(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      CMS 1500 Form
    </Button>
  );

  const renderAssessmentFormButton = () => (
    <Button
      color="info"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handleAssessmentForm(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      Assessment Form
    </Button>
  );

  const renderProofOfDelivery = () => (
    <Button
      color="success"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handleProofOfDeliveryPreviw(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      Proof Of Delivery
    </Button>
  );

  const handlePDFPreviewAction = async (row: OrderInfo) => {
    const documentId = row.orderDocumentId ? row.orderDocumentId : 0;
    const actionResult = await dispatch(fetchOrderDocumentById(documentId));
    const documentData = actionResult.payload;

    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - ORDER`,
        fileName: row.orderNumber,
      });
    }
  };

  const handlePackagePreview = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewPackagePDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Packing List`,
        fileName: row.orderNumber + "_PackingList",
      });
    }
  };

  const handleSalesInvoicePreviw = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewSalesPDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Sales Invoice`,
        fileName: row.orderNumber + "_SalesInvoice",
      });
    }
  };

  const handlePrescriptionPrview = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewPrescriptionPDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Prescription`,
        fileName: row.orderNumber + "_Prescription",
      });
    }
  };

  const handleCMSPrview = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewCMSPDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - CMS 1500 Form`,
        fileName: row.orderNumber + "_CMS1500Form",
      });
    }
  };

  const handleProofOfDeliveryPreviw = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewProofOfDelivery(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Proof Of Delivery`,
        fileName: row.orderNumber + "_ProofOfDelivery",
      });
    }
  };

  const handleAssessmentForm = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewEvaltionForm(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Assessment Form`,
        fileName: row.orderNumber + "_AssessmentForm",
      });
    }
  };
  //

  const detailsRows = orderItemRow?.map((row: any) => {
    const hasMenuItems =
      row.tissueTrackingDocumentId ||
      row.returnDocumentId ||
      row.tissueTrackingInfo.imagesOfWounds?.length ||
      row.tissueTrackingInfo.medicalNotes?.length ||
      row.uploadedProductPackageIds?.length ||
      row.comment;

    return {
      ...row,
      status: orderItemStatus(row),
      action: hasMenuItems ? (
        <Box display="flex" alignItems="center" gap={0.5}>
          {row.tissueTrackingDocumentId || row.returnDocumentId ? (
            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage="Document"
              onClick={() => handlePreviewAction(row)}
            >
              <AssignmentOutlined fontSize="small" />
            </CustomIconButton>
          ) : null}

          {row.tissueTrackingInfo.imagesOfWounds?.length ||
          row.uploadedProductPackageIds?.length ? (
            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage="Image"
              onClick={() => handleImageViewAction(row)}
            >
              <WallpaperOutlined fontSize="small" />
            </CustomIconButton>
          ) : null}

          {row.tissueTrackingId &&
          row.tissueTrackingInfo.medicalNotes?.length ? (
            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage="Medical Note"
              onClick={() => handleViewMedicalNotesAction(row)}
            >
              <NoteAddOutlined fontSize="small" />
            </CustomIconButton>
          ) : null}

          {row.comment ? (
            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage={
                row.tissueTrackingId
                  ? "Comment Record product usage"
                  : "Comment Return product"
              }
              onClick={() => showCustomCommentPopup(row)}
            >
              <CommentOutlined fontSize="small" />
            </CustomIconButton>
          ) : null}
        </Box>
      ) : null,
      invoiceDate: (
        <Box display="flex" alignItems="center" gap={1}>
          {row.invoiceNumber && canAccessApplication ? (
            <>
              <Typography sx={{ color: "#42A5F5", cursor: "pointer" }}>
                <Link
                  component="button"
                  underline="hover"
                  variant="body2"
                  onClick={() =>
                    navigate("/invoice_list", {
                      state: { orderNumber: order?.orderNumber },
                    })
                  }
                  color={colors.info[300]}
                >
                  {row.invoiceNumber}
                </Link>
              </Typography>
              <Typography>
                {row.invoiceDate && <span>{row.invoiceDate}</span>}
              </Typography>
            </>
          ) : (
            <Typography>
              {row.invoiceNumber && row.invoiceDate
                ? `${row.invoiceNumber} ${row.invoiceDate}`
                : "-"}
            </Typography>
          )}
        </Box>
      ),
    };
  });

  const handleShipmentTracking = (order: OrderInfo) => {
    setShipmentInfoOpen(true);
  };
  const totalAmount = detailsRows?.reduce((sum: any, row: any) => {
    return sum + Number(row?.quantity * row.extendedPrice);
  }, 0);

  const totalPrice = detailsRows
    .filter((row) => !(row.productReturnId && row.productReturnStatus === ORDER_AVAILABILITY.RETURNED))//CS-1164
    .reduce((sum, row) => {
      if (row.extendedPrice != null && row.units != null) {
        return (
          sum +
          (row.hasSKUPrice ? row.extendedPrice : row.extendedPrice * row.units)
        );
      }
      return sum;
    }, 0);

  const orderObj: OrderFulfillmentInfo = {
    orderId: order?.orderId || 0,
    practiceId: order?.practiceId || 0,
    ivrId: order?.ivrId || 0,
    patientId: order?.patientId || 0,
    practiceName: order?.practiceName || "",
    manufacturerName: order?.manufacturerName || "",
    poNumber: order?.poNumber || "",
    orderStatusToUpdate: order?.orderStatus || "",
    updateStatusDate: new Date().toISOString(),
    dateOfService: order?.dateOfService || "",
    patientName: order?.patientName || "",
    productName: order?.productName || "",
    providerName: order?.providerName || "",
    orderNumber: order?.orderNumber || "",
    orderDate: order?.orderDate || "",
    orderType: order?.orderType || "",
    orderStatus: order?.orderStatus || "",
    mfgConfirmationNumber: order?.mfgConfirmationNumber || "",
    shippedDate: order?.shippedDate || "",
    deliveredDate: order?.deliveredDate || "",
    processedDate: order?.processedDate || "",
    shippingCarrier: order?.shippingCarrier || "",
    trackingNumber: order?.trackingNumber || "",
    orderItems: orderItemsListInfo || [],
    manufacturerOrderId: order?.manufacturerOrderId || "",
    manufacturerPatientId: order?.manufacturerPatientId || "",
  };

  const handleEditClick = () => {
    setPoNumberValue(order?.poNumber || getValues("po") || "");
    setIsEditing(true);
  };

  const renderPoNumberComponent = () => {
    return (
      <CustomTextField
        controllerName="po"
        autoFocus
        control={control}
        value={poNumberValue}
        onChange={(event) => {
          setPoNumberValue(event.target.value);
        }}
        onBlur={async () => {
          setIsEditing(false);
          const newValue = poNumberValue.trim();

          if (
            (newValue && newValue !== getValues("po")) ||
            newValue !== order?.poNumber
          ) {
            setValue("po", newValue);

            const updatePoNumber = {
              ...orderObj,
              poNumber: newValue,
            };

            try {
              const response = await dispatch(
                updateOrder({
                  orderUpdataData: updatePoNumber,
                  interceptorOption: { skipErrorPopup: true },
                })
              );

              if (
                response.payload &&
                response.payload.code === "V3OK" &&
                response.payload.message === "SUCCESS"
              ) {
                let successObj: SingleAlertInfo = {
                  message: "Po Number updated successfully",
                  alertType: "success",
                };
                dispatch(setSingleAlertObj(successObj));

                navigate(location.pathname, {
                  state: {
                    ...location.state,
                    orderDetails: {
                      ...order,
                      poNumber: newValue,
                    },
                  },
                  replace: true,
                });
              }
            } catch (error) {
              console.error("Error updating PO number:", error);
            }
          } else {
            const originalValue = getValues("po") || order?.poNumber || "";
            setPoNumberValue(originalValue);
          }
        }}
        name="po"
      />
    );
  };

  const showExcelPopupData = (event: React.MouseEvent<HTMLElement>) => {
    setShowExcelPopup(true)
  };

  const handleDocumentsMenuClose = () => {
    setDocumentsMenuAnchor(null);
  };

  const renderDocumentsMenuButton = () => (
    <Box display="flex" alignItems="center" gap={0.5}>
      {canViewExcelData && (
      <Button
        color="success"
        variant="outlined"
        sx={{ whiteSpace: "nowrap", mr: 1 }}
        onClick={showExcelPopupData}
        startIcon={<img src={require("../../../assets/excel_icon.png")} alt="Excel Icon" style={{ width: 24, height: 24 }} />}>
          View Excel Data
      </Button>
      )}
      <Menu
        anchorEl={documentsMenuAnchor}
        open={Boolean(documentsMenuAnchor)}
        onClose={handleDocumentsMenuClose}
      >
        {order?.orderDocumentId != null && (
          <MenuItem
            onClick={() => {
              handlePDFPreviewAction(order);
              handleDocumentsMenuClose();
            }}
          >
            <Typography ml={1}>PDF</Typography>
          </MenuItem>
        )}
        {order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && (
          <MenuItem
            onClick={() => {
              handlePackagePreview(order);
              handleDocumentsMenuClose();
            }}
          >
            <Typography ml={1}>Packing List</Typography>
          </MenuItem>
        )}
        {order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE &&
          canAccessSalesInvoice && (
            <MenuItem
              onClick={() => {
                handleSalesInvoicePreviw(order);
                handleDocumentsMenuClose();
              }}
            >
              <Typography ml={1}>Sales Invoice</Typography>
            </MenuItem>
          )}
        {order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && (
          <MenuItem
            onClick={() => {
              handlePrescriptionPrview(order);
              handleDocumentsMenuClose();
            }}
          >
            <Typography ml={1}>Prescription</Typography>
          </MenuItem>
        )}
        {order?.patientId != null && (
          <MenuItem
            onClick={() => {
              handleCMSPrview(order);
              handleDocumentsMenuClose();
            }}
          >
            <Typography ml={1}>CMS 1500 Form</Typography>
          </MenuItem>
        )}
        {order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && (
          <MenuItem
            onClick={() => {
              handleAssessmentForm(order);
              handleDocumentsMenuClose();
            }}
          >
            <Typography ml={1}>Assessment Form</Typography>
          </MenuItem>
        )}
        {order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE &&
          order.orderStatus === "DELIVERED" && (
            <MenuItem
              onClick={() => {
                handleProofOfDeliveryPreviw(order);
                handleDocumentsMenuClose();
              }}
            >
              <Typography ml={1}>Proof Of Delivery</Typography>
            </MenuItem>
          )}
      </Menu>
    </Box>
  );

  const handleSignatureData = async (data: any) => {
    const payload = {
      orderId: location?.state?.orderDetails?.orderId,
      providerName: data?.providerInformation?.name,
      signature: data?.providerInformation?.signature,
    };
    await dispatch(saveProviderSignAgainstOrder(payload))
      .then((response) => {
        if (response.payload && response.payload?.code === SUCCESS_CODE) {
          dispatch(
            setSingleAlertObj({
              alertType: "success",
              message: `Order (${location?.state?.orderDetails?.orderNumber}) signed successfully!`,
            })
          );
          navigate("/order_list");
        }
      })
      .catch((error) => {
        dispatch(
          setSingleAlertObj({
            alertType: "error",
            message: "Something went wrong while signing the order!",
          })
        );
      });
  };

  return (
    <Box
      sx={{
        margin: {
          xs: "20px 10px",
          sm: "20px",
        },
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{ m: "0 0 5px 0" }}
          >
            Order Details - <span style={{color: colors.info[300]}}>{order?.orderNumber}</span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          display="flex"
          flexDirection="column"
          sx={{ justifyContent: { xs: "flex-start", md: "flex-end" } }}
        >
          <Box
            display="flex"
            alignItems="center"
            sx={{ justifyContent: { xs: "flex-start", md: "flex-end" } }}
            gap={1}
            pb={1}
          >
            {renderDocumentsMenuButton()}

            <Button
              color="warning"
              variant="outlined"
              startIcon={<Create />}
              style={{
                display: `${hideElement(
                  !canSignOrder ||
                    location?.state?.orderDetails?.orderStatus !==
                      ORDER_STATUS.PENDING
                )}`,
              }}
              onClick={() => setShowSignatureSubmitPopup(true)}
            >
              SIGN ORDER
            </Button>
          </Box>
        </Grid>
      </Grid>

      {showPDF && (
        <PDFViewer
          isOpen={showPDF.isShow}
          onClose={() =>
            setShowPDF({ isShow: false, productName: "", fileName: "" })
          }
          title={showPDF.productName}
          fileName={showPDF.fileName}
          base64String={orderDocumentInfo?.content || ""}
        />
      )}

      {showSignatureSubmitPopup && (
        <SigantureSubmitPopup
          open={showSignatureSubmitPopup}
          onClose={() => {
            setShowSignatureSubmitPopup(false);
          }}
          addProductItem={() => {}}
          productItemDetails={{}}
          isEdit={false}
          practiceName={location?.state?.orderDetails?.practiceName}
          selectedProviderData={[
            {
              providerName: location?.state?.orderDetails?.orderInfo?.provider,
              npi: "",
              ptan: "",
              taxId: "",
            },
          ]} //
          addSignature={handleSignatureData}
          authorizedSigner={false}
        />
      )}

<Box
  sx={{
    border: 1,
    p: 2,
    borderRadius: 3,
    borderColor: colors.grey[700],
  }}
>
  <Grid container spacing={3}>
    <Grid item md={9} xs={12} sx={{ order: { xs: 2, md: 1 } }}>
      <Card sx={{ padding: 0 }}>
        <Box
          sx={{
            position: "relative",
            borderRadius: 2,
          }}
        >
          {!isMobile && (
            <Divider
              orientation="vertical"
              sx={{
                position: "absolute",
                left: "50%",
                top: 0,
                bottom: 0,
                transform: "translateX(-50%)",
                borderRightWidth: 1,
                borderRightStyle: "dashed",
                borderColor: colors.grey[700],
              }}
              flexItem
            />
          )}
          <Grid container height="100%">
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  p: 2,
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={1}
                >
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    sx={{ color: colors.success[300] }}
                  >
                    Serial Numbers
                  </Typography>

                  <Tooltip title="Copy all" placement="top" arrow>
                    <IconButton
                      size="small"
                      onClick={() =>
                        navigator.clipboard.writeText(allSerialNumbers.join(", "))
                      }
                      disabled={allSerialNumbers.length === 0}
                    >
                      <ContentCopy fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    maxHeight: 220,
                    overflow: "auto",
                    pr: 0.5,
                  }}
                >
                  {allSerialNumbers.length > 0 ? (
                    allSerialNumbers.map((sn, index) => (
                      <Tooltip
                        title="Click to copy"
                        key={`${sn}-${index}`}
                        placement="top"
                        arrow
                      >
                        <Chip
                          label={sn}
                          size="small"
                          clickable
                          onClick={() => navigator.clipboard.writeText(sn)}
                          variant="outlined"
                          sx={{
                            fontFamily:
                              'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
                            borderColor: colors.grey[700],
                          }}
                        />
                      </Tooltip>
                    ))
                  ) : (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ fontStyle: 'italic' }}
                    >
                      No serial numbers available
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box p={2}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  sx={{ color: colors.success[300], mb: 1 }}
                >
                  Size Mix
                </Typography>
                {allSizes.length > 0 ? (
                  allSizes.map((size, index) => (
                    <Chip
                      key={`${size}-${index}`}
                      label={size}
                      size="small"
                      sx={{
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? "#2C3E50"
                            : colors.grey[700],
                        padding: "1px 10px",
                        fontWeight: "bold",
                        border: "1px solid ",
                        borderColor:
                          theme.palette.mode === "dark"
                            ? "#34495E"
                            : colors.grey[700],
                        mr: 1,
                        mb: 1,
                      }}
                    />
                  ))
                ) : (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontStyle: 'italic' }}
                  >
                    No size information available
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
              <Box
                sx={{
                  borderBottom: "1px dashed",
                  borderColor: colors.grey[700],
                }}
              />
              <Box p={2}>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="h6" fontWeight="bold">
                    TOTAL
                  </Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {SalesDetailsInfo && SalesDetailsInfo.length > 1 ? priceFormatter(order?.orderTotalPrice ?? 0) : firstSalesDetail ? priceFormatter(firstSalesDetail.cogsSalesOrig) : priceFormatter(0)}
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>

          <Grid item md={3} xs={12} sx={{ order: { xs: 1, md: 2 } }}>
            <Card sx={{ padding: 0 }}>
              <Box p={2}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  sx={{ color: colors.success[300], marginBottom: 2 }}
                >
                  Info
                </Typography>
                {/* {order?.productCategory &&
                  order?.productCategory !== "PRODUCT_CATEGORY.CONSERVATIVE" && (
                    <Grid container mt={2}>
                      <Grid item xs={6}>
                        <Typography color={colors.grey[500]}>
                          Product
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>
                          {`${order?.productName} (${order?.manufacturerName})`}
                        </Typography>
                      </Grid>
                    </Grid>
                  )} */}

                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>Product</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>
                      {firstSalesDetail?.product || firstSalesDetail?.mfg
                        ? `${firstSalesDetail.product || ""} ${firstSalesDetail.mfg ? `(${firstSalesDetail.mfg})` : ""}`.trim()
                        : "-"
                      }
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>Provider</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>
                      {firstSalesDetail ? firstSalesDetail.provider : "-" }
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>Practice</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{firstSalesDetail ? firstSalesDetail.accountPractice : "-" }</Typography>
                  </Grid>
                </Grid>

                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>Order ID</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{order?.orderNumber || "-"}</Typography>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>MFR</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{firstSalesDetail ? firstSalesDetail.mfg : "-" }</Typography>
                  </Grid>
                </Grid>
                {/* <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>
                      MFG Confirm #
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>30825-SI</Typography>
                  </Grid>
                </Grid> */}
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>Agency</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{firstSalesDetail ? firstSalesDetail.agency : "-" }</Typography>
                  </Grid>
                </Grid>

                {/* <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>
                      Manufacturer Order ID
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{order?.manufacturerOrderId || "-"}</Typography>
                  </Grid>
                </Grid> */}
                {/* <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>
                      PO (if applicable)
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    {isEditing ? (
                      renderPoNumberComponent()
                    ) : order?.poNumber || getValues("po") ? (
                      <Tooltip title="Click to edit" placement="top" arrow>
                        <Typography
                          component="span"
                          onClick={handleEditClick}
                          sx={{
                            cursor: "pointer",
                            fontWeight: "medium",
                            "&:hover": {
                              color: "#38bdf8",
                              textDecoration: "underline",
                            },
                          }}
                        >
                          {order?.poNumber || getValues("po")}
                        </Typography>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Click to add PO#" placement="top" arrow>
                        <Typography
                          component="span"
                          onClick={handleEditClick}
                          sx={{
                            cursor: "pointer",
                            color: colors.grey[400],
                            "&:hover": { textDecoration: "underline" },
                          }}
                        >
                          -
                        </Typography>
                      </Tooltip>
                    )}
                  </Grid>
                </Grid> */}
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>
                      Date of Service
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{firstSalesDetail ? firstSalesDetail.dos : "-" }</Typography>
                  </Grid>
                </Grid>
                {order?.additionalNotes && (
                  <Grid container mt={2}>
                    <Grid item xs={6}>
                      <Typography color={colors.grey[500]}>
                        Additional Notes
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Tooltip title="Show Notes" placement="top" arrow>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (order?.additionalNotes) {
                              showCustomCommentPopupFromOrderForm(order);
                            }
                          }}
                        >
                          <CommentOutlined fontSize="small" />
                        </span>
                      </Tooltip>
                    </Grid>
                  </Grid>
                )}
                {/* <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>Carrier</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{order?.shippingCarrier || "-"}</Typography>
                  </Grid>
                </Grid> */}
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>
                      Shipping Tracking #
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>
                      { firstSalesDetail && firstSalesDetail.trackingNum !== null ? firstSalesDetail.trackingNum : "-" }
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>
                      Invoice ID
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>
                      {firstSalesDetail && firstSalesDetail.invoiceNum !== null ? (
                        <Typography sx={{
                          color: "#42A5F5",
                          cursor: "pointer",
                          flexShrink: 0
                        }}>
                          {/* <Link
                            component="button"
                            underline="hover"
                            variant="body2"
                            onClick={() =>
                              navigate("/invoice_list", {
                                state: { orderNumber: order?.orderNumber },
                              })
                            }
                            color={colors.info[300]}
                          >
                            {parseInt(firstSalesDetail.invoiceNum).toString()}
                          </Link> */}
                          {SalesDetailsInfo && SalesDetailsInfo.filter(detail => detail.invoiceNum !== null).map((detail, index) => (
                            <React.Fragment key={index}>
                              <Link
                                component="button"
                                underline="hover"
                                variant="body2"
                                onClick={() =>
                                  navigate("/invoice_list", {
                                    state: { orderNumber: order?.orderNumber },
                                  })
                                }
                                color={colors.info[300]}
                              >
                                {detail.invoiceNum}
                              </Link>
                              {index < SalesDetailsInfo.filter(d => d.invoiceNum !== null).length - 1 && ", "}
                            </React.Fragment>
                          ))}
                        </Typography>
                      ) : (
                        "-"
                      )}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>Status</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>
                      {order?.orderStatus === "DELIVERED" ? (
                        <span style={{ color: "#28a745" }}>
                          {order?.orderStatus}
                        </span>
                      ) : order?.orderStatus === "SHIPPED" ? (
                        <span style={{ color: "#5dabff" }}>
                          {order?.orderStatus}
                        </span>
                      ) : order?.orderStatus === "CANCELED" ? (
                        <span style={{ color: "#dc3545" }}>
                          {order?.orderStatus}
                        </span>
                      ) : order?.orderStatus === "PROCESSING" ? (
                        <span style={{ color: "#fd7e14" }}>
                          {order?.orderStatus}
                        </span>
                      ) : (
                        "-"
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                {/* <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>
                      Requested Delivery Date
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>
                      {order?.requestedDeliveryDate || "-"}
                    </Typography>
                  </Grid>
                </Grid> */}
                {(isNotPlacedOrCanceled ||
                  isProcessing ||
                  isShipped ||
                  isDelivered) &&
                  order?.orderInfo?.processedDate && (
                    <Grid container mt={2}>
                      <Grid item xs={6}>
                        <Typography color={colors.grey[500]}>
                          Processed Date
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>
                          {order?.orderInfo?.processedDate || "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  )}

                {(isNotPlacedOrCanceled || isShipped || isDelivered) &&
                  order?.shippedDate && (
                    <Grid container mt={2}>
                      <Grid item xs={6}>
                        <Typography color={colors.grey[500]}>
                          Shipped Date
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>{order?.shippedDate || "-"}</Typography>
                      </Grid>
                    </Grid>
                  )}

                {(isNotPlacedOrCanceled || isDelivered) &&
                  order?.deliveredDate && (
                    <Grid container mt={2}>
                      <Grid item xs={6}>
                        <Typography color={colors.grey[500]}>
                          Date Of Delivery
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>{order?.deliveredDate || "-"}</Typography>
                      </Grid>
                    </Grid>
                  )}

                {/* <Grid container mt={2}>
                  <Grid item xs={6}>
                    <Typography color={colors.grey[500]}>
                      Shipping Method
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>
                      {order?.requestedShippingMethod || "-"}
                    </Typography>
                  </Grid>
                </Grid> */}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Grid display="flex" justifyContent="flex-end">
        <Grid item>
          <Button
            color="info"
            startIcon={<ArrowBack />}
            onClick={() => navigate(-1)}
            sx={{ mt: 2, mb: 4 }}
          >
            Back
          </Button>
        </Grid>
      </Grid>
      <CustomCommentPopup
        open={showCommentPopup}
        onClose={hideCustomCommentPopup}
        title={commentData.title}
        commentBody={commentData.body}
      />

      <ShipmentInfoPopup
        open={shipmentInfoOpen}
        onClose={() => setShipmentInfoOpen(false)}
        trackingNumber={order?.trackingNumber || ""}
        orderId={order?.orderId || 0}
        orderNumber={order?.orderNumber || "-"}
        shipper={{
          city: trackingData?.shipping_info?.shipper_address?.city || "",
          state: trackingData?.shipping_info?.shipper_address?.state || "",
          postal_code:
            trackingData?.shipping_info?.shipper_address?.postal_code || "",
        }}
        recipient={{
          city: trackingData?.shipping_info?.recipient_address?.city || "",
          state: trackingData?.shipping_info?.recipient_address?.state || "",
          postal_code:
            trackingData?.shipping_info?.recipient_address?.postal_code || "",
        }}
        status={orderTrackingLogs?.status || ""}
        carrierName={orderTrackingLogs?.carrier || ""}
        shippingDate={shippingDate}
        departureTime={departureTime}
        expectedArrival={
          orderTrackingLogs?.status === "Delivered"
            ? actualDeliveryTime
            : expectedArrivalFrom !== "N/A" && expectedArrivalTo !== "N/A"
            ? expectedArrivalFrom + " - " + expectedArrivalTo
            : expectedArrivalFrom !== "N/A"
            ? expectedArrivalFrom
            : expectedArrivalTo
        }
        events={scanEvents}
        milestones={dateAndTimes.map((d: any) => d.type)}
      />
      <ExcelDetailsPopup onClose={()=>setShowExcelPopup(false)} open={showExcelPopup} rows={SalesDetailsInfo}/>
    </Box>
  );
};

export default MigrateDetails;
